import { Mail, Phone, UserRound } from "lucide-react";

const inputCls = "w-full p-2.5 rounded-xl border border-slate-200 outline-none focus:ring-2 focus:ring-[#0A66C2] text-sm";

export const EMPTY_GUEST = { name: "", phone: "", email: "", doc: "" };

export const guestError = (form, accepted) => {
  if (form.name.trim().split(/\s+/).length < 2) return "Informe seu nome completo.";
  if (form.phone.replace(/\D/g, "").length < 10) return "Informe um WhatsApp válido com DDD.";
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email.trim())) return "Informe um e-mail válido.";
  if (!accepted) return "Para continuar, aceite os Termos de Uso e a Política de Cancelamento.";
  return null;
};

export const guestPayload = (form) => ({
  guest_name: form.name.trim(),
  guest_phone: form.phone.trim(),
  guest_email: form.email.trim(),
  guest_doc: form.doc.trim() || null,
});

const Field = ({ label, icon: Icon, children }) => (
  <div className="mb-3">
    <label className="text-[11px] font-bold text-slate-500 uppercase mb-1.5 flex items-center gap-1.5">
      <Icon className="w-3 h-3" /> {label}
    </label>
    {children}
  </div>
);

export const GuestFields = ({ form, setForm }) => {
  const bind = (k) => ({ value: form[k], onChange: (e) => setForm({ ...form, [k]: e.target.value }), className: inputCls });
  return (
    <>
      <Field label="Nome completo" icon={UserRound}><input {...bind("name")} placeholder="Maria da Silva" autoComplete="name" data-testid="input-name" /></Field>
      <Field label="WhatsApp" icon={Phone}><input {...bind("phone")} placeholder="(13) 99999-9999" type="tel" inputMode="tel" autoComplete="tel" data-testid="input-phone" /></Field>
      <Field label="E-mail" icon={Mail}><input {...bind("email")} type="email" placeholder="voce@email.com" autoComplete="email" data-testid="input-email" /></Field>
      <Field label="CPF (opcional)" icon={UserRound}><input {...bind("doc")} placeholder="000.000.000-00" inputMode="numeric" data-testid="input-doc" /></Field>
    </>
  );
};

export const TermsCheckbox = ({ accepted, setAccepted }) => (
  <label className="flex items-start gap-2.5 text-xs text-slate-600 mb-4 cursor-pointer" data-testid="accept-terms">
    <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)}
      className="mt-0.5 w-4 h-4 accent-[#0A66C2] shrink-0" data-testid="accept-terms-checkbox" />
    <span>
      Li e aceito os <a href="/termos" target="_blank" rel="noreferrer" className="text-[#0A66C2] font-semibold underline">Termos de Uso</a>, a{" "}
      <a href="/cancelamento" target="_blank" rel="noreferrer" className="text-[#0A66C2] font-semibold underline">Política de Cancelamento</a> e a{" "}
      <a href="/privacidade" target="_blank" rel="noreferrer" className="text-[#0A66C2] font-semibold underline">Política de Privacidade</a>.
    </span>
  </label>
);
